import { trigger, transition, style, animate } from '@angular/animations';
import {
    ChangeDetectorRef,
    Component,
    computed,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';

import { FileState } from '../../../../../interfaces/file-state.interface';
import { UploadService } from '../../../../../services/upload-progress.service';
import {
    SearchInputFileTypeIconPath,
    SearchInputFileTypeName,
} from '../../enums/search-input-file.enum';
import { SearchInputFile } from '../../interfaces/search-input-file.interface';

@Component({
    selector: 'mapp-search-input-files',
    templateUrl: './search-input-files.component.html',
    styleUrls: ['./search-input-files.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('400ms ease-in', style({ opacity: 1 })),
            ]),
            transition(':leave', [animate('400ms ease-out', style({ opacity: 0 }))]),
        ]),
    ],
    standalone: false,
})
export class SearchInputFilesComponent implements OnChanges {
    private progressService = inject(UploadService);

    @Input() files: FileState[];

    @Output() delete: EventEmitter<FileState> = new EventEmitter();

    allFiles: SearchInputFile[] = [];

    uploadProgress = computed(() => this.progressService.progress());

    showConversationUploadProgress = computed(() =>
        this.progressService.showConversationUploadProgress()
    );

    progressFlag = computed(() => this.progressService.progressCompleted);

    isTemporaryFile = computed(() => this.progressService.selectedFileTemporaryConsent);

    // removed local tooltip state: parent component will handle tooltip rendering

    /**
     *
     * @param ref
     */
    constructor(private readonly ref: ChangeDetectorRef) {}

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes?.files?.currentValue) {
            this.allFiles = changes.files.currentValue.map((file: FileState) => {
                const { parsedName, typeName, iconPath } = this.getTypeData(file);
                return {
                    id: file.id,
                    name: file.name,
                    parsedName,
                    typeName,
                    iconPath,
                    size: file.size,
                    type: file.type,
                } as SearchInputFile;
            });
            this.ref.detectChanges();
        }
    }

    /**
     * @param file
     */
    handleDelete(file: SearchInputFile) {
        // this.progressService.reset();
        this.delete.emit(this.files.find((item) => item.id === file.id));
    }

    /**
     *
     * @param file
     */
    private getTypeData(file): { parsedName; typeName; iconPath } {
        const type = file.name.substring(file.name.lastIndexOf('.') + 1).toUpperCase();
        const parsedName = file.name.substring(0, file.name.length - type.length - 1);

        return {
            parsedName,
            typeName: SearchInputFileTypeName[type] || type,
            iconPath: SearchInputFileTypeIconPath[type] || null,
        };
    }
}
